// Actions
import {
  editEvent as editEventAction,
  retrieveActionEvents as retrieveActionEventsAction,
} from 'app/shared/eventsOld/actions';

// Utils
import { post, put } from 'app/shared/utils/fetchr';
import routes from 'app/shared/utils/routes';

export const editEvent = (
  request: ReturnType<typeof editEventAction>['payload'],
) => {
  const { eventId, ...details } = request;
  const path = routes.patronus.eventsEventId.replace(
    ':eventId',
    String(eventId),
  );
  return put(path, details);
};

export const retrieveActionEvents = (
  payload: ReturnType<typeof retrieveActionEventsAction>['payload'],
) => {
  return post(routes.patronus.actionEventsList, payload);
};
